export const initialState = {
  sesionUsuario: {
    autenticado: false,
    usuario: null,
  },
  openSnackbar: {
    open: false,
    mensaje: "",
  },
  drawer: {
    isCollapsed: false,
  },
  institution: null,
};